import React,{useEffect,useState} from 'react';
import axios from 'axios'
import RightArrow from './img/bi_arrow-right-short.png';
import {comma,instance} from './common'
import trash from './img/trash.png'
function totalPrice(data,co_discount){
    let price = 0;
    data.forEach(function(v){
        price += Number(v.s_member_price);
        if(v.c_option){
            JSON.parse(v.c_option).forEach(function(items){
                price += Number(items.price);
            });
        }
    });
    price =  price-co_discount;

    return comma(price);
}


function MyReserve({history}){
    const session = JSON.parse(window.sessionStorage.result);
    const {u_id} = session;
     const [data, setData] = useState([]);
     const [reload, setReload] = useState(0);

     let obj = {u_id:u_id}
     useEffect(() => {
         
         const fetchData = async () => {
            instance.post('/reserve/id',obj).then(function(res){
 
                 setData(res.data);
             });
  
         };
 
         fetchData();
 
     }, [reload]);

     console.log('data : ', data)


     const goDetail = (e) => {
         const {r_id,si_id,date} = e.target.dataset;
         history.push('/reserve_detail?r_id='+r_id+'&si_id='+si_id+'&date='+date);
     }

     const goDetail2 = (e) => {
        const {r_id,si_id,date} = e.target.dataset;
        history.push('/repReserve_detail?r_id='+r_id+'&si_id='+si_id+'&date='+date);
    }

    const s_trash = {
        position:'absolute',
        right:'0',
        width:'48px',
        top:'35px'
    }
    const delReserve = (e) => {
        const {num,r_id} = e.target.dataset;
        console.log('num : ', num)
        if(num){
            //alert('계약번호가 인증된 내역입니다.');
            instance.post('/reserve/r_id',{r_id:r_id}).then(function(res){
                if(res.data[0].r_status === '예약완료'){
                    console.log('인증까지만 된 상태');
                    if(window.confirm('정말 삭제하시겠습니까?')){
                        instance.post('/reserve/delete',{r_id:r_id}).then(function(res){
                        
                        });
                        let updateObj = {
                            obj:{co_car_id:0,is_use:0,co_user_id:null,co_user_id2:null},
                            whereField:'co_number',
                            whereValue:num
                        }
                        instance.post('/contract/update',updateObj).then(function(res){
                            setReload(reload+1);  
                        });
                    }

                }else if(res.data[0].r_status === '결제완료'){
                    console.log('인증하고 결제까지 된 상태');
                    if(window.confirm('정말 삭제하시겠습니까? \n(결제가 된 건 이므로 환불처리가 진행됩니다.)')){
                        alert('본사와 협의 후 환불을 진행 해주세요.');
                        //window.location.replace('https://abys-service.co.kr/inisys/refund.php');
                    }
                }else if(res.data[0].r_status === '입고완료' || res.data[0].r_status === '검수완료'){
                    console.log('결제하고 작업까지 된 상태');
                    alert('본사와 협의 후 환불을 진행 해주세요.');
                }else if(res.data[0].r_status === '작업완료'){
                    console.log('작업완료 된 상태');
                    alert('작업이 완료된 건은 환불이 불가능합니다.');
                }
            });
            
        }else{
            if(window.confirm('정말 삭제하시겠습니까?')){
                const fetchData = async () => {
                    instance.post('/reserve/delete',{r_id:r_id}).then(function(res){
                        setReload(reload+1)     
                    });
          
                 };
         
                 fetchData();
            }
        }
        
    }

    return (
        <div className="container mb-5">
        <div className="row">
            <div className="S_calendar_title pb-2" style={{position:'relative'}}>서비스 예약 내역</div>
            
            {
                data.map(v => <div className="s_calendar_main_content" key={v.r_id}>
                <div className="S_calendar_content2 pb-3 pt-3" style={{position:'relative'}}>
                    <div className="S_calendar_content">시공업체 : {v.si_name}</div>
                    <div className="S_calendar_date">{v.r_reserve_date}
                        {
                            v.s_id
                            ?
                            <div style={s_trash}>
                                <img className="w-50" src={RightArrow} onClick={goDetail}  data-r_id={v.r_id} data-si_id={v.si_id} data-date={v.r_reserve_date}/>
                                <img className="w-50" src={trash} onClick={delReserve} data-num={v.contract_num} data-r_id={v.r_id}/>
                            </div>
                            
                            :
                            <div style={s_trash}>
                                <img className="w-50" src={RightArrow} onClick={goDetail2}  data-r_id={v.r_id} data-si_id={v.si_id} data-date={v.r_reserve_date}/>
                                <img className="w-50" src={trash} onClick={delReserve} data-num={v.contract_num} data-r_id={v.r_id}/>
                            </div>
                        }
                    </div>
                    <span className="S_calendar_money">
                        {v.s_id ? totalPrice(JSON.parse(v.s_id),v.co_discount) : <span>-</span>} 원</span>
                </div>
            </div>)
            }
        </div>
    </div>
    )
}


export default MyReserve;